import { Button } from '@autopass-web/mochi-component';
import { CheckInImage } from './check-in-image';
import styles from './index.module.scss';
import { timeFormatter } from '@autopass-web/domain';
import type { ParkingRecordBill } from '@autopass-web/types';

interface ParkingRecordListItemProps {
  parkingRecordBill: ParkingRecordBill;
  onClick: () => void;
}

export const ParkingRecordListItem = ({
  parkingRecordBill,
  onClick,
}: ParkingRecordListItemProps) => {
  const {
    plate_number,
    checked_in_at,
    store_is_support_alpr,
    checked_in_image_url,
  } = parkingRecordBill;
  const formattedTime = timeFormatter(checked_in_at, 'full');

  return (
    <div className={styles.card} onClick={onClick}>
      {store_is_support_alpr && <CheckInImage image={checked_in_image_url} />}
      <div className={styles.info}>
        <div>
          <div className={styles['plate-number']}>{plate_number}</div>
          <div className={styles['check-in']}>進場：{formattedTime}</div>
        </div>
        <Button type="text" size="large">
          選擇
        </Button>
      </div>
    </div>
  );
};
